import React, { useState } from 'react'

const SeeMoreLess = ({ content, limit }) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const toggleContent = () => {
        setIsExpanded(!isExpanded)
    }
    // Create a new DOMParser instance
    const parser = new DOMParser()
    // Parse the HTML string
    const doc = parser.parseFromString(content, 'text/html')
    const textContent = doc.body.textContent || ''
    const normalizedContent = textContent?.trim() || ''
    // console.log(normalizedContent, '@content')
    const getTruncatedContent = (text, maxLength) => {
        if (text.length <= maxLength) return text
        const truncated = text.substring(0, maxLength).trim()
        const lastSpaceIndex = truncated.lastIndexOf(' ')
        return lastSpaceIndex > 0
            ? truncated.substring(0, lastSpaceIndex) + '...'
            : truncated + '...'
    }
    const truncatedContent = getTruncatedContent(normalizedContent, limit)
    return (
        <>
            <div style={{ display: 'inline' }}>
                <span
                    className="proDesc"
                    dangerouslySetInnerHTML={{
                        __html: isExpanded ? normalizedContent : truncatedContent,
                    }}
                />
                {content && content.length > limit && (
                    <span style={{ display: 'inline' }}>
                        {' '}
                        <button
                            style={{ display: 'inline' }}
                            className="seeMoreLess"
                            onClick={toggleContent}
                        >
                            {isExpanded ? 'See Less' : 'See More'}
                        </button>
                    </span>
                )}
            </div>
        </>
    )
}

export default SeeMoreLess
